import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Form, Input } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createPageData,
  sparePartRequestFormData,
} from "./SparePartRequestFile";
import { getRecords, saveRecords } from "../../services/api.service";
import { toast } from "react-toastify";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";
import CustomError from "../../custom/components/Errors/CustomError";
import { imageURL } from "../../services/api.service";
import NumberInput from "../../custom/components/Number-Input/NumberInput";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import { validate } from "../../custom/validations/Validate";
import { LoaderCreatePage } from "../Loader/Loader";
import { loaderOverlay } from "../../Style/loaderOverly";
import DatePicker from "../../custom/components/Date-Picker/DatePicker";

const SparePartRequestCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    referenceOptions,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(sparePartRequestFormData());
  const [invoiceSelect, setInvoiceSelect] = useState("");
  const [invoiceSelectOptions, setInvoiceSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const delivery_challen_doc_ref = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState(
    formData?.inputData?.inward_items || []
  );
  const [selectedJobCard, setSelectedJobCard] = useState(null);
  const [jobCardSelectOptions, setJobCardSelectOptions] = useState([]);

  const [selectedSparePart, setSelectedSparePart] = useState(null);
  const [sparePartSelectOptions, setSparePartSelectOptions] = useState([]);

  const [selectedRequestedBy, setSelectedRequestedBy] = useState(null);
  const [requestedBySelectOptions, setRequestedBySelectOptions] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusSelectOptions, setStatusSelectOptions] = useState([
    { value: 1, label: "Pending" },
  ]);

  const schema = localStorage.getItem("schema");

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };

      if (id) {
        payload.whereCondition = { id };
      }

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data?.length > 0) {
        let data = responseData.data[0];

        setFormData({ inputData: data });

        // Safely set job card
        setSelectedJobCard({
          value: data?.job_card_id || null,
          label: data?.job_card?.job_card_no || "-",
        });

        // Safely set spare
        setSelectedSparePart({
          value: data?.spare_id || null,
          label: data?.spare?.name || "-",
        });

        // Status selection
        const foundStatus = statusSelectOptions.find(
          (sts) => sts.label === data?.status
        );

        if (foundStatus) {
          setSelectedStatus({
            value: foundStatus.value,
            label: foundStatus.label,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = validate(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);

      setFormErrors(validationErrors);
      if (JSON.stringify(validationErrors) !== "{}") return;
      // Additional validation for `user_documents`

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData.inputData };
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData };
      }
      const now = new Date();

      payload.inputData = {
        ...payload.inputData,
        requested_by: userDetails.id,
        requested_at: new Date().toISOString().replace("T", " ").slice(0, 19),
      };

      console.log(payload);
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getJobCardData();
    getSparePartData();
  }, []);

  const getJobCardData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "job_cards",
        whereCondition: {
          is_active: true,
          technician_check_is_repairable: true,
          status: "Pending",
        },
        schema: schema,
        orderBy: {
          field: "job_card_no",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.job_card_no,
      }));
      setJobCardSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleJobCardSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      job_card_id: selectedValue,
    });

    setSelectedJobCard(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      job_card_id: fieldError?.job_card_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        job_card_id: selectedValue,
      },
    }));
  };

  const getSparePartData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "material_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "name",
          order: "asc",
        },
        include: [
          {
            model: "category_masters",
            as: "category",
            where: {
              type: 1,
            },
            required: true, // IMPORTANT
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setSparePartSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleSparePartSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      spare_id: selectedValue,
    });

    setSelectedSparePart(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      spare_id: fieldError?.spare_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        spare_id: selectedValue,
      },
    }));
  };

  const handleStatusSelect = (options) => {
    const selectedValue = options ? options.label : "";
    const fieldError = validate(validationType, {
      status: selectedValue,
    });

    setSelectedStatus(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      status: fieldError?.status || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        status: selectedValue,
      },
    }));
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        {id && (
          <Col md="6" className="mt-3">
            <TextInput
              label="Spare Part Request No"
              name="spare_part_request_no"
              value={formData?.inputData?.spare_part_request_no}
              placeholder="Spare Part Request No"
              inputClassName="form-control"
              labelClassName="form-label"
              asterisk={true}
              disabled={true}
              customError={formErrors?.spare_part_request_no}
            />
          </Col>
        )}

        <Col md="6" className="mt-3">
          <SelectInput
            label="Job Card"
            options={jobCardSelectOptions}
            value={selectedJobCard}
            onSelect={handleJobCardSelect}
            placeholder="Select Job Card"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.job_card_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Spare Part"
            options={sparePartSelectOptions}
            value={selectedSparePart}
            onSelect={handleSparePartSelect}
            placeholder="Select Spare Part"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.spare_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="Quantity"
            name="quantity"
            value={formData?.inputData?.quantity}
            onChange={onInputChange}
            placeholder="Quantity"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.quantity}
          />
        </Col>

        {/* <Col md="6" className="mt-3">
          <TextInput
            label="Issue Qty"
            name="issue_qty"
            value={formData?.inputData?.issue_qty}
            onChange={onInputChange}
            placeholder="Issue Qty"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.issue_qty}
          />
        </Col> */}
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default SparePartRequestCreate;
